var map = {
	"./chat.png": "7050",
	"./contact.png": "3891",
	"./contract.png": "096e",
	"./document.png": "4ae8",
	"./event.png": "576b",
	"./member.png": "70bf",
	"./note.png": "5aa1",
	"./post.png": "780f",
	"./project.png": "f264",
	"./schedule.png": "b5bc",
	"./scheme.png": "a31d",
	"./worklog.png": "74d8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d63d";